<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import type { CareersProps } from "./CareersProps.js";
	import translations from "./Careers.translations.json";
	import Link from "../components/Link.svelte";
	import { aboutPathMap } from "../../../core/schema/paths/aboutPathMap.js";
	import { getTenant } from "../getTenant.js";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";
	import ContactForm from "../components/Contact/ContactForm.svelte";
	import HeadingSection from "../components/HeadingSection.svelte";
	import CareerSection from "../components/CareerSection.svelte";

	type $$Props = CareersProps;

	const { positions } = $$restProps as $$Props;
	const tenant = getTenant();

	const translate = getTranslate(translations);
</script>

<Layout>
	<div class="border-lttertiary border-b">
		<div class="container">
			<HeadingSection tag={translate("tag")} headline={translate("introductoryHeadline")}>
				<div class="lg:text-md mb-5 leading-normal tracking-[0.02em]">{translate("introductoryDesc1")}</div>
				<div class="lg:text-md mb-5 leading-normal tracking-[0.02em]">{translate("introductoryDesc2")}</div>
				<div class="lg:text-md mb-5 leading-normal tracking-[0.02em]">{translate("introductoryDesc3")}</div>
				<Link
					asButton
					variant="secondary"
					class="mt-12 xl:mt-16"
					icon={arrowRight}
					href="/{aboutPathMap[tenant.locale]}">{translate("moreAboutUs")}</Link
				>
			</HeadingSection>
		</div>
	</div>

	<section class="mt-24">
		<CareerSection {positions} headline={translate("openPositions")} />
	</section>

	<section class="!mb-0">
		<ContactForm containerClass="md:mx-16 mx-4 xl:mx-32" />
	</section>
</Layout>
